import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "timestamp"
}
const _hoisted_3 = {
  key: 0,
  class: "timeline-dot"
}

import { DateTime } from "luxon";
import { TANDEM_TIME_WITH_SECONDS } from "@/core";

export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineEvent',
  props: {
    label: {},
    timestamp: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["timeline-item", _ctx.label ? 'date-marker' : 'activity-item'])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.timestamp)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (!_ctx.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.timestamp.toFormat(_unref(TANDEM_TIME_WITH_SECONDS))), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? _renderSlot(_ctx.$slots, "default", { key: 2 })
      : _createCommentVNode("", true)
  ], 2))
}
}

})